import type { EdutainmentApplication } from '../../types';

export const PENDING_RELEASE_APPLICATIONS: EdutainmentApplication[] = [
  {
    _id: '001',
    name: '手作皮革工藝',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員', '白金卡會員'],
    category: '技藝',
    reviewDeadline: 1752249600000,
    autoReleaseDate: 1752336000000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 5,
    startDate: 1760198400000,
    endDate: 1775923200000,
    times: ['星期二14:00~16:00', '星期四14:00~16:00'],
    teacher: '林志明',
    administrator: '王主任',
  },
  {
    _id: '002',
    name: '油畫創作班',
    plans: ['金卡會員', '鑽卡會員', '白金卡會員'],
    category: '藝術',
    reviewDeadline: 1753459200000,
    autoReleaseDate: 1753545600000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 5,
    startDate: 1761408000000,
    endDate: 1777132800000,
    times: ['星期三09:00~11:00', '星期六09:00~11:00'],
    teacher: '陳藝術',
    administrator: '李主任',
  },
  {
    _id: '003',
    name: '太極拳班',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員', '白金卡會員'],
    category: '運動',
    reviewDeadline: 1754668800000,
    autoReleaseDate: 1754755200000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 8,
    startDate: 1762617600000,
    endDate: 1778342400000,
    times: ['星期一07:00~08:30', '星期四07:00~08:30'],
    teacher: '王大師',
    administrator: '張主任',
  },
  {
    _id: '004',
    name: '日式料理教學',
    plans: ['金卡會員', '鑽卡會員', '白金卡會員'],
    category: '烹飪',
    reviewDeadline: 1755878400000,
    autoReleaseDate: 1755964800000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 6,
    startDate: 1763827200000,
    endDate: 1779552000000,
    times: ['星期二18:00~20:00', '星期五18:00~20:00'],
    teacher: '山田健一',
    administrator: '劉主任',
  },
  {
    _id: '005',
    name: '日語會話班',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員'],
    category: '語言',
    reviewDeadline: 1757088000000,
    autoReleaseDate: 1757174400000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 10,
    startDate: 1765036800000,
    endDate: 1780761600000,
    times: ['星期三20:00~21:30', '星期六20:00~21:30'],
    teacher: '佐藤美咲',
    administrator: '陳主任',
  },
  {
    _id: '006',
    name: '盆栽藝術',
    plans: ['金卡會員', '鑽卡會員', '白金卡會員'],
    category: '技藝',
    reviewDeadline: 1758297600000,
    autoReleaseDate: 1758384000000,
    status: '待上架',
    currentEnrollment: 0,
    minimumEnrollment: 5,
    startDate: 1766246400000,
    endDate: 1781971200000,
    times: ['星期一15:00~16:30', '星期五15:00~16:30'],
    teacher: '黃園藝',
    administrator: '林主任',
  },
];
